import { render, staticRenderFns } from "./addBDForm.vue?vue&type=template&id=10480214&scoped=true&"
import script from "./addBDForm.vue?vue&type=script&lang=js&"
export * from "./addBDForm.vue?vue&type=script&lang=js&"
import style0 from "./addBDForm.vue?vue&type=style&index=0&id=10480214&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10480214",
  null
  
)

export default component.exports